import formatMoney from "../../../../utils/formatMoney";

export default function SoldValue({ dates }: any) {
  return (
    <div className="border border-gray-300 px-4 py-2 bg-red-100 h-20">
      <div className="flex justify-between items-center">
        <div className="flex-1">
          <div className="flex justify-between">
            <div className="text-lg">Sold Value [ USD ]</div>
          </div>
          <div className="text-xl font-bold">
            {/* $ {formatMoney(Number(329082) || 0)} */}-
          </div>
        </div>
      </div>
    </div>
  );
}
